var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 221,
    viewBox: "0 0 289 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2266 -29.6957C35.0466 -17.3396 25.8266 -2.04895 18.9966 14.1272C7.25658 41.9284 4.34657 78.8113 26.7066 98.5604C39.7866 110.082 58.2566 112.523 75.4566 111.833C92.6566 111.143 109.887 107.848 126.987 109.918C144.087 111.987 161.827 120.904 168.457 137.266C173.457 149.55 171.387 163.883 176.097 176.28C184.507 198.398 208.827 214.543 231.357 209.446C253.887 204.349 276.167 181.696 295.587 168.887C324.957 149.498 358.527 133.816 393.357 135.742",
    stroke: "#EE2A7B",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.927 -52.5134C86.5266 -32.9496 37.9266 21.8703 56.7966 55.5097C60.8766 62.7998 68.4966 67.4539 76.4266 69.4824C95.2366 74.2909 115.107 68.0614 134.077 67.9276C152.867 67.7937 170.217 72.7773 184.167 86.0807C202.167 103.225 192.617 136.463 211.857 153.792C233.727 173.469 260.097 147.49 274.607 132.303C308.137 97.2218 352.997 88.6755 399.377 90.3744",
    stroke: "#FDB8FF",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave3);
export default __webpack_public_path__ + "static/media/wave3.851f30aab040421bdce49c15fb1b47c8.svg";
export { ForwardRef as ReactComponent };